<div
  fxLayout="row"
  [fxLayoutAlign]="applymentModel.personName && applymentModel.logged ? 'start center': 'end center'"
  class="ps-client-side-nav-content">
  <div
    *ngIf="applymentModel.personName && applymentModel.logged"
    fxFlex>
    <mat-icon class="person-icon" svgIcon="person-stroke"></mat-icon>
    <span
      [title]="applymentModel.personName"
      class="ps-client-side-nav-text">
      {{applymentModel.personName}}
    </span>
  </div>
  <div fxLayout="row" fxFlexAlign="center end">
    <button
      mat-icon-button
      aria-label="Fechar menu"
      (click)="openCloseMenu()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div class="rb-padding-0x16">
  <mat-divider></mat-divider>
</div>
<mat-nav-list class="rb-menu-list-itens">
  <div
    class="new_applyment_button"
    [style.padding.px]="16"
    *ngIf="applymentModel.logged && isPortalInscrito()"
    (click)="goToNewApplyment()"
    >
    <a
      [style.width]="'100%'"
      color="primary"
      mat-raised-button>
      Nova inscrição
    </a>
  </div>
  <a
    *ngIf="applymentModel.logged"
    mat-list-item
    color="primary"
    [routerLink]="'portal-inscrito'"
    (click)="openCloseMenu()">
    Portal do inscrito
  </a>
  <a
    *ngIf="applymentModel.getSettings().user_details_page_id !== null && applymentModel.logged"
    mat-list-item
    color="primary"
    (click)="goToUserDetails()">
    Meus dados
  </a>
  <a
    *ngIf="applymentModel.logged"
    mat-list-item
    color="primary"
    (click)="leaveProcess()">
    Sair
  </a>
  <a
    *ngIf="!applymentModel.logged"
    mat-list-item
    color="primary"
   (click)="openLoginDialog()">
   Login
  </a>
</mat-nav-list>
